import React, { ReactNode } from "preact/compat";
import classNames from "classnames";
import styles from "./index.module.scss";
import { LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";

export interface FixFormProps {
  head?: ReactNode;
  body?: ReactNode;
  footer?: ReactNode;
  className?: string;
}
export const FixForm: React.FC<FixFormProps> = ({ head, body, footer, className }) => {
  const { layoutType } = useLayoutType();

  return (
    <div className={classNames(styles.root, layoutType === LayoutTypes.TYPE_DESKTOP && styles.desktop)}>
      {head && <div className={styles.head}>{head}</div>}
      {body && <div className={styles.body}>{body}</div>}
      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
};

export default FixForm;
